import { MATRIX_CELL_WIDTH } from '@/constants';

export default function getGridDetails(data) {
  // Extract x and y values from the JSON data
  const cells = [];

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      cells.push(data[key]);
    }
  }

  // Sort cells by y value first, then by x value
  cells.sort((a, b) => (a.y !== b.y ? a.y - b.y : a.x - b.x));

  // Get unique y values to determine rows
  const uniqueYValues = [...new Set(cells.map(cell => cell.y))];

  // Group cells by rows
  const cellsInRow = uniqueYValues.reduce((acc, y) => {
    return [...acc, [{ cells: cells.filter(cell => cell.y === y).map(cell => ({ type: 'cell', width: MATRIX_CELL_WIDTH, children: [] })) }]];
  }, []);

  return cellsInRow;
}
